import {inject, injectable} from 'inversify';

import type {BNFormApiModel} from '../../../../../api/types/bnrks/models';

import {ChoiceQuestionMapperJrpc} from '../../ChoiceQuestion/mappers/ChoiceQuestion.mapper.jrpc';
import {TextQuestionMapperJrpc} from '../../TextQuestion/mappers/TextQuestion.mapper.jrpc';

type Question = BNFormApiModel['sections'][0]['questions'][0];

@injectable()
export class QuestionMapperJrpc {
  constructor(
    @inject(ChoiceQuestionMapperJrpc)
    private readonly choiceQuestionMapper: ChoiceQuestionMapperJrpc,
    @inject(TextQuestionMapperJrpc)
    private readonly textQuestionMapper: TextQuestionMapperJrpc,
  ) {}

  mapSectionsToModels(data: BNFormApiModel['sections']) {
    return data.flatMap(section =>
      section.questions.map(question => this.mapToModel(question)),
    );
  }

  mapToModel(data: Question) {
    switch (data.type) {
      case 'long_text':
      case 'short_text':
        return this.textQuestionMapper.mapToModel(data);
      case 'multiple_choice':
      case 'single_choice':
        return this.choiceQuestionMapper.mapToModel(data);
      default:
        throw new Error(`Unknown question type: ${data.type}`);
    }
  }
}
